import { defineMessages } from "./define";

export const financeMessages = defineMessages({
  ru: {
    "finance.method_card": "Карта",
    "finance.method_sbp": "СБП",
    "finance.eyebrow": "Финансы",
    "finance.page_eyebrow": "Аналитика",
    "finance.title": "Финансы",
    "finance.subtitle": "Баланс, пополнения, выводы и история операций",
    "finance.period_30": "30 дней",
    "finance.period_90": "90 дней",
    "finance.period_all": "Всё время",
    "finance.available_balance": "Доступный баланс",
    "finance.withdraw_restricted_hint": "Вывод средств ограничен. Обратитесь в поддержку.",
    "finance.withdraw_restricted": "Вывод ограничен",
    "finance.topup": "Пополнить",
    "finance.withdraw": "Вывести",
    "finance.pending_withdrawal": "Вывод в обработке",
    "finance.support": "Написать в поддержку",
    "finance.nfts_in_portfolio": "NFT в портфеле",
    "finance.show": "Показать",
    "finance.turnover": "Оборот",
    "finance.dynamics_region": "Динамика",
    "finance.dynamics_title": "Динамика операций",
    "finance.period": "Период",
    "finance.withdrawn": "Выведено",
    "finance.deposited": "Пополнено",
    "finance.skipped_currencies": "Операции в других валютах ({count}) не включены в итог по выбранной валюте.",
    "finance.history_title": "История операций",
    "finance.loading_history": "Загружаем историю",
    "finance.history_empty_title": "Операций пока нет",
    "finance.history_empty_desc": "Пополнения и выводы появятся здесь.",
    "finance.modal_topup": "Пополнение баланса",
    "finance.modal_withdraw": "Вывод средств",
    "finance.col_date": "Дата",
    "finance.col_type": "Тип",
    "finance.col_method": "Способ",
    "finance.col_details": "Реквизиты",
    "finance.col_amount": "Сумма",
    "finance.col_status": "Статус",
    "finance.status_expired": "Истекло",
    "finance.status_pending": "Обработка",
    "finance.status_rejected": "Отклонено",
    "finance.status_success": "Успешно",
    "finance.status_unknown": "Статус {status}",
    "finance.type_deposit": "Пополнение",
    "finance.type_withdraw": "Вывод",
    "finance.type_unknown": "Операция {type}",
    "finance.qr_hide": "Скрыть QR-код",
    "finance.invoice_title": "Реквизиты для оплаты",
    "finance.invoice_subtitle": "Переведите точную сумму по указанным реквизитам.",
    "finance.invoice_send_amount": "Сумма к отправке",
    "finance.invoice_open_payment": "Перейти к оплате",
    "finance.invoice_qr_hint": "Отсканируйте в приложении кошелька — адрес и сумма подставятся автоматически.",
    "finance.invoice_time_to_pay": "Время на оплату",
    "finance.qr_show": "Показать QR-код",
    "finance.qr_alt": "QR-код кошелька для пополнения",
    "finance.qr_caption": "Сканируйте для оплаты",
    "finance.chart_empty": "Пока нет подтверждённых операций за выбранный период.",
    "finance.chart_label": "Динамика баланса пополнений и выводов, сейчас {amount}",
    "finance.loading_methods": "Загружаем способы",
    "finance.error_min_amount": "Минимальная сумма — {amount}.",
    "finance.error_check_amount": "Проверьте сумму и способ операции.",
    "finance.error_select_bank": "Выберите банк для вывода через СБП.",
    "finance.error_select_method": "Выберите способ",
    "finance.page_topup": "Пополнение",
    "finance.page_topup_desc": "Выберите доступный способ и сумму пополнения",
    "finance.page_withdraw_desc": "Создайте запрос на вывод на ваши реквизиты",
    "finance.min_hint": "Минимум {amount}",
    "finance.bank": "Банк",
    "finance.select_bank": "Выберите банк",
    "finance.withdraw_blocked": "Вывод средств временно недоступен для вашего аккаунта.",
    "finance.withdraw_created": "Запрос на вывод создан.",
    "finance.sync_warning": "Не удалось обновить данные аккаунта. Обновите страницу.",
    "finance.sending": "Отправляем…",
    "finance.continue": "Продолжить",
    "finance.create_request": "Создать запрос",
    "finance.payment_created": "Платёж создан",
    "finance.payment_number": "Платёж #{id}",
    "finance.open_payment": "Открыть оплату",
    "finance.paid_no_balance_title": "Оплатили, но баланс не изменился?",
    "finance.paid_no_balance_desc": "Средства зачисляются после подтверждения платежа. Если этого не произошло, напишите в поддержку и укажите номер платежа.",
    "finance.confirmation_eyebrow": "Подтверждение",
    "finance.confirm_title": "Подтвердите вывод",
    "finance.creating_request": "Создаём запрос…",
    "finance.confirm_withdraw": "Подтвердить вывод",
    "finance.cancel": "Отмена",
    "finance.amount_due": "Сумма к оплате",
    "finance.network": "Сеть",
    "finance.wallet_address": "Адрес кошелька",
    "finance.copy_wallet": "Скопировать адрес кошелька",
    "finance.memo": "Memo / тег",
    "finance.copy_memo": "Скопировать memo",
    "finance.pay_until": "Оплатить до",
    "finance.minimum": "Минимальная сумма",
    "finance.network_warning": "Отправляйте средства только в указанной сети. Перевод в другой сети приведёт к потере средств.",
    "finance.time_left": "осталось {time}",
    "finance.time_expired": "время истекло",
    "finance.copied": "Скопировано",
    "finance.finance_desk": "Финансовый отдел",
    "finance.copy": "Копировать",
    "finance.analytics_region": "Аналитика портфеля",
    "finance.portfolio_value": "Оценка портфеля",
    "finance.portfolio_value_hint": "Оценка по текущим ценам",
    "finance.realized": "Реализованная прибыль",
    "finance.realized_hint": "Сумма всех продаж минус сумма всех покупок",
    "finance.realized_unknown_hint": "Нужна цена покупки проданных NFT",
    "finance.spent": "Потрачено",
    "finance.received": "Получено",
    "finance.best": "Лучший актив",
    "finance.worst": "Худший актив",
    "finance.stats_unavailable": "Отображаются доступные показатели вашего портфеля.",
    "finance.portfolio_chart_title": "Стоимость портфеля",
    "finance.portfolio_chart_unavailable": "История стоимости портфеля пока недоступна.",
    "finance.portfolio_chart_error": "Не удалось загрузить график.",
    "finance.loading_short": "Загружаем…",
    "finance.portfolio_chart_label": "Стоимость портфеля, {period}",
    "finance.period_1d": "1 д",
    "finance.period_7d": "7 д",
    "finance.period_30d": "30 д",
    "finance.period_60d": "60 д",
    "finance.period_90d": "90 д",
    "finance.period_180d": "180 д",
    "finance.period_365d": "365 д",
    "finance.period_1y": "1 г",
    "finance.period_all_short": "Всё",
    "finance.owns_eyebrow": "Портфель",
    "finance.owns_title": "Мои NFT",
    "finance.tab_portfolio": "Портфель",
    "finance.tab_history": "История",
    "finance.col_collection": "Коллекция",
    "finance.col_token": "Токен ID",
    "finance.col_price": "Цена",
    "finance.nft_sold": "Продан",
    "finance.nft_on_sale": "На продаже",
    "finance.nft_bought": "Куплен",
    "finance.nft_in_collection": "В коллекции",
    "finance.nft_history_empty_title": "История пуста",
    "finance.nft_history_empty_desc": "Операции с NFT появятся здесь.",
    "finance.items_count": "one:{count} предмет|few:{count} предмета|many:{count} предметов|other:{count} предмета",
    "finance.search_placeholder": "Найти в портфеле",
    "finance.loading_assets": "Загружаем активы",
    "finance.assets_empty_title": "Активов не найдено",
    "finance.assets_empty_query": "Измените поисковый запрос.",
    "finance.assets_empty_desc": "Купленные NFT появятся здесь."
  },
  en: {
    "finance.method_card": "Card",
    "finance.method_sbp": "Fast payment (SBP)",
    "finance.eyebrow": "Finance",
    "finance.page_eyebrow": "Analytics",
    "finance.title": "Finance",
    "finance.subtitle": "Balance, top-ups, withdrawals and transaction history",
    "finance.period_30": "30 days",
    "finance.period_90": "90 days",
    "finance.period_all": "All time",
    "finance.available_balance": "Available balance",
    "finance.withdraw_restricted_hint": "Withdrawals are restricted. Please contact support.",
    "finance.withdraw_restricted": "Withdrawals restricted",
    "finance.topup": "Top up",
    "finance.withdraw": "Withdraw",
    "finance.pending_withdrawal": "Withdrawal in progress",
    "finance.support": "Contact support",
    "finance.nfts_in_portfolio": "NFTs in portfolio",
    "finance.show": "View",
    "finance.turnover": "Turnover",
    "finance.dynamics_region": "Activity",
    "finance.dynamics_title": "Transaction activity",
    "finance.period": "Period",
    "finance.withdrawn": "Withdrawn",
    "finance.deposited": "Deposited",
    "finance.skipped_currencies": "Transactions in other currencies ({count}) are excluded from the total for the selected currency.",
    "finance.history_title": "Transaction history",
    "finance.loading_history": "Loading history",
    "finance.history_empty_title": "No transactions yet",
    "finance.history_empty_desc": "Top-ups and withdrawals will appear here.",
    "finance.modal_topup": "Top up balance",
    "finance.modal_withdraw": "Withdraw funds",
    "finance.col_date": "Date",
    "finance.col_type": "Type",
    "finance.col_method": "Method",
    "finance.col_details": "Details",
    "finance.col_amount": "Amount",
    "finance.col_status": "Status",
    "finance.status_expired": "Expired",
    "finance.status_pending": "Processing",
    "finance.status_rejected": "Rejected",
    "finance.status_success": "Completed",
    "finance.status_unknown": "Status {status}",
    "finance.type_deposit": "Top-up",
    "finance.type_withdraw": "Withdrawal",
    "finance.type_unknown": "Transaction {type}",
    "finance.qr_hide": "Hide QR code",
    "finance.invoice_title": "Payment details",
    "finance.invoice_subtitle": "Send the exact amount using the details below.",
    "finance.invoice_send_amount": "Amount to send",
    "finance.invoice_open_payment": "Go to payment",
    "finance.invoice_qr_hint": "Scan with your wallet app — the address and amount fill in automatically.",
    "finance.invoice_time_to_pay": "Time to pay",
    "finance.qr_show": "Show QR code",
    "finance.qr_alt": "Deposit wallet QR code",
    "finance.qr_caption": "Scan to pay",
    "finance.chart_empty": "No confirmed transactions for the selected period yet.",
    "finance.chart_label": "Net top-ups and withdrawals over time, currently {amount}",
    "finance.loading_methods": "Loading methods",
    "finance.error_min_amount": "The minimum amount is {amount}.",
    "finance.error_check_amount": "Check the amount and the method.",
    "finance.error_select_bank": "Choose a bank for the SBP withdrawal.",
    "finance.error_select_method": "Select a method",
    "finance.page_topup": "Top-up",
    "finance.page_topup_desc": "Choose an available method and the top-up amount",
    "finance.page_withdraw_desc": "Create a withdrawal request to your payment details",
    "finance.min_hint": "Minimum {amount}",
    "finance.bank": "Bank",
    "finance.select_bank": "Choose a bank",
    "finance.withdraw_blocked": "Withdrawals are temporarily unavailable for your account.",
    "finance.withdraw_created": "Withdrawal request created.",
    "finance.sync_warning": "Couldn't refresh your account data. Please reload the page.",
    "finance.sending": "Sending…",
    "finance.continue": "Continue",
    "finance.create_request": "Create request",
    "finance.payment_created": "Payment created",
    "finance.payment_number": "Payment #{id}",
    "finance.open_payment": "Open payment page",
    "finance.paid_no_balance_title": "Paid but your balance hasn't changed?",
    "finance.paid_no_balance_desc": "Funds are credited once the payment is confirmed. If that hasn't happened, contact support and include the payment number.",
    "finance.confirmation_eyebrow": "Confirmation",
    "finance.confirm_title": "Confirm the withdrawal",
    "finance.creating_request": "Creating request…",
    "finance.confirm_withdraw": "Confirm withdrawal",
    "finance.cancel": "Cancel",
    "finance.amount_due": "Amount due",
    "finance.network": "Network",
    "finance.wallet_address": "Wallet address",
    "finance.copy_wallet": "Copy wallet address",
    "finance.memo": "Memo / tag",
    "finance.copy_memo": "Copy memo",
    "finance.pay_until": "Pay by",
    "finance.minimum": "Minimum amount",
    "finance.network_warning": "Send funds only on the specified network. A transfer on another network will result in the loss of funds.",
    "finance.time_left": "{time} left",
    "finance.time_expired": "time is up",
    "finance.copied": "Copied",
    "finance.finance_desk": "Finance department",
    "finance.copy": "Copy",
    "finance.analytics_region": "Portfolio analytics",
    "finance.portfolio_value": "Portfolio value",
    "finance.portfolio_value_hint": "Valued at current prices",
    "finance.realized": "Realized P&L",
    "finance.realized_hint": "Total sales minus total purchases",
    "finance.realized_unknown_hint": "Purchase price of sold NFTs is required",
    "finance.spent": "Spent",
    "finance.received": "Received",
    "finance.best": "Best asset",
    "finance.worst": "Worst asset",
    "finance.stats_unavailable": "Your available portfolio figures are shown.",
    "finance.portfolio_chart_title": "Portfolio value",
    "finance.portfolio_chart_unavailable": "Portfolio value history is currently unavailable.",
    "finance.portfolio_chart_error": "Couldn't load the chart.",
    "finance.loading_short": "Loading…",
    "finance.portfolio_chart_label": "Portfolio value, {period}",
    "finance.period_1d": "1D",
    "finance.period_7d": "7D",
    "finance.period_30d": "30D",
    "finance.period_60d": "60D",
    "finance.period_90d": "90D",
    "finance.period_180d": "180D",
    "finance.period_365d": "365D",
    "finance.period_1y": "1Y",
    "finance.period_all_short": "All",
    "finance.owns_eyebrow": "Portfolio",
    "finance.owns_title": "My NFTs",
    "finance.tab_portfolio": "Portfolio",
    "finance.tab_history": "History",
    "finance.col_collection": "Collection",
    "finance.col_token": "Token ID",
    "finance.col_price": "Price",
    "finance.nft_sold": "Sold",
    "finance.nft_on_sale": "On sale",
    "finance.nft_bought": "Bought",
    "finance.nft_in_collection": "In collection",
    "finance.nft_history_empty_title": "No history yet",
    "finance.nft_history_empty_desc": "NFT transactions will appear here.",
    "finance.items_count": "one:{count} item|few:{count} items|many:{count} items|other:{count} items",
    "finance.search_placeholder": "Search your portfolio",
    "finance.loading_assets": "Loading assets",
    "finance.assets_empty_title": "No assets found",
    "finance.assets_empty_query": "Try a different search.",
    "finance.assets_empty_desc": "NFTs you buy will appear here."
  },
  ua: {
    "finance.method_card": "Картка",
    "finance.method_sbp": "Швидкий платіж (СБП)",
    "finance.eyebrow": "Фінанси",
    "finance.page_eyebrow": "Аналітика",
    "finance.title": "Фінанси",
    "finance.subtitle": "Баланс, поповнення, виведення та історія операцій",
    "finance.period_30": "30 днів",
    "finance.period_90": "90 днів",
    "finance.period_all": "Весь час",
    "finance.available_balance": "Доступний баланс",
    "finance.withdraw_restricted_hint": "Виведення коштів обмежено. Зверніться до підтримки.",
    "finance.withdraw_restricted": "Виведення обмежено",
    "finance.topup": "Поповнити",
    "finance.withdraw": "Вивести",
    "finance.pending_withdrawal": "Виведення в обробці",
    "finance.support": "Написати в підтримку",
    "finance.nfts_in_portfolio": "NFT у портфелі",
    "finance.show": "Показати",
    "finance.turnover": "Оборот",
    "finance.dynamics_region": "Динаміка",
    "finance.dynamics_title": "Динаміка операцій",
    "finance.period": "Період",
    "finance.withdrawn": "Виведено",
    "finance.deposited": "Поповнено",
    "finance.skipped_currencies": "Операції в інших валютах ({count}) не включено до підсумку за вибраною валютою.",
    "finance.history_title": "Історія операцій",
    "finance.loading_history": "Завантажуємо історію",
    "finance.history_empty_title": "Операцій поки немає",
    "finance.history_empty_desc": "Поповнення та виведення з'являться тут.",
    "finance.modal_topup": "Поповнення балансу",
    "finance.modal_withdraw": "Виведення коштів",
    "finance.col_date": "Дата",
    "finance.col_type": "Тип",
    "finance.col_method": "Спосіб",
    "finance.col_details": "Реквізити",
    "finance.col_amount": "Сума",
    "finance.col_status": "Статус",
    "finance.status_expired": "Минуло",
    "finance.status_pending": "Обробка",
    "finance.status_rejected": "Відхилено",
    "finance.status_success": "Успішно",
    "finance.status_unknown": "Статус {status}",
    "finance.type_deposit": "Поповнення",
    "finance.type_withdraw": "Виведення",
    "finance.type_unknown": "Операція {type}",
    "finance.qr_hide": "Сховати QR-код",
    "finance.invoice_title": "Реквізити для оплати",
    "finance.invoice_subtitle": "Переведіть точну суму за вказаними реквізитами.",
    "finance.invoice_send_amount": "Сума до відправлення",
    "finance.invoice_open_payment": "Перейти до оплати",
    "finance.invoice_qr_hint": "Скануйте в застосунку гаманця — адреса і сума підставляться автоматично.",
    "finance.invoice_time_to_pay": "Час на оплату",
    "finance.qr_show": "Показати QR-код",
    "finance.qr_alt": "QR-код гаманця для поповнення",
    "finance.qr_caption": "Скануйте для оплати",
    "finance.chart_empty": "Поки немає підтверджених операцій за вибраний період.",
    "finance.chart_label": "Динаміка балансу поповнень і виведень, зараз {amount}",
    "finance.loading_methods": "Завантажуємо способи",
    "finance.error_min_amount": "Мінімальна сума — {amount}.",
    "finance.error_check_amount": "Перевірте суму та спосіб операції.",
    "finance.error_select_bank": "Виберіть банк для виведення через СБП.",
    "finance.error_select_method": "Виберіть спосіб",
    "finance.page_topup": "Поповнення",
    "finance.page_topup_desc": "Виберіть доступний спосіб і суму поповнення",
    "finance.page_withdraw_desc": "Створіть запит на виведення на ваші реквізити",
    "finance.min_hint": "Мінімум {amount}",
    "finance.bank": "Банк",
    "finance.select_bank": "Виберіть банк",
    "finance.withdraw_blocked": "Виведення коштів тимчасово недоступне для вашого акаунта.",
    "finance.withdraw_created": "Запит на виведення створено.",
    "finance.sync_warning": "Не вдалося оновити дані акаунта. Оновіть сторінку.",
    "finance.sending": "Надсилаємо…",
    "finance.continue": "Продовжити",
    "finance.create_request": "Створити запит",
    "finance.payment_created": "Платіж створено",
    "finance.payment_number": "Платіж #{id}",
    "finance.open_payment": "Відкрити оплату",
    "finance.paid_no_balance_title": "Оплатили, але баланс не змінився?",
    "finance.paid_no_balance_desc": "Кошти зараховуються після підтвердження платежу. Якщо цього не сталося, напишіть у підтримку та вкажіть номер платежу.",
    "finance.confirmation_eyebrow": "Підтвердження",
    "finance.confirm_title": "Підтвердьте виведення",
    "finance.creating_request": "Створюємо запит…",
    "finance.confirm_withdraw": "Підтвердити виведення",
    "finance.cancel": "Скасувати",
    "finance.amount_due": "Сума до оплати",
    "finance.network": "Мережа",
    "finance.wallet_address": "Адреса гаманця",
    "finance.copy_wallet": "Скопіювати адресу гаманця",
    "finance.memo": "Memo / тег",
    "finance.copy_memo": "Скопіювати memo",
    "finance.pay_until": "Оплатити до",
    "finance.minimum": "Мінімальна сума",
    "finance.network_warning": "Надсилайте кошти лише в зазначеній мережі. Переказ в іншій мережі призведе до втрати коштів.",
    "finance.time_left": "залишилося {time}",
    "finance.time_expired": "час минув",
    "finance.copied": "Скопійовано",
    "finance.finance_desk": "Фінансовий відділ",
    "finance.copy": "Копіювати",
    "finance.analytics_region": "Аналітика портфеля",
    "finance.portfolio_value": "Оцінка портфеля",
    "finance.portfolio_value_hint": "Оцінка за поточними цінами",
    "finance.realized": "Реалізований прибуток",
    "finance.realized_hint": "Сума всіх продажів мінус сума всіх покупок",
    "finance.realized_unknown_hint": "Потрібна ціна купівлі проданих NFT",
    "finance.spent": "Витрачено",
    "finance.received": "Отримано",
    "finance.best": "Найкращий актив",
    "finance.worst": "Найгірший актив",
    "finance.stats_unavailable": "Показано доступні показники вашого портфеля.",
    "finance.portfolio_chart_title": "Вартість портфеля",
    "finance.portfolio_chart_unavailable": "Історія вартості портфеля наразі недоступна.",
    "finance.portfolio_chart_error": "Не вдалося завантажити графік.",
    "finance.loading_short": "Завантажуємо…",
    "finance.portfolio_chart_label": "Вартість портфеля, {period}",
    "finance.period_1d": "1 д",
    "finance.period_7d": "7 д",
    "finance.period_30d": "30 д",
    "finance.period_60d": "60 д",
    "finance.period_90d": "90 д",
    "finance.period_180d": "180 д",
    "finance.period_365d": "365 д",
    "finance.period_1y": "1 р",
    "finance.period_all_short": "Усе",
    "finance.owns_eyebrow": "Портфель",
    "finance.owns_title": "Мої NFT",
    "finance.tab_portfolio": "Портфель",
    "finance.tab_history": "Історія",
    "finance.col_collection": "Колекція",
    "finance.col_token": "Токен ID",
    "finance.col_price": "Ціна",
    "finance.nft_sold": "Продано",
    "finance.nft_on_sale": "У продажу",
    "finance.nft_bought": "Куплено",
    "finance.nft_in_collection": "У колекції",
    "finance.nft_history_empty_title": "Історія порожня",
    "finance.nft_history_empty_desc": "Операції з NFT з'являться тут.",
    "finance.items_count": "one:{count} предмет|few:{count} предмети|many:{count} предметів|other:{count} предмета",
    "finance.search_placeholder": "Знайти в портфелі",
    "finance.loading_assets": "Завантажуємо активи",
    "finance.assets_empty_title": "Активів не знайдено",
    "finance.assets_empty_query": "Змініть пошуковий запит.",
    "finance.assets_empty_desc": "Куплені NFT з'являться тут."
  },
  bl: {
    "finance.method_card": "Карта",
    "finance.method_sbp": "Хуткі плацёж (СБП)",
    "finance.eyebrow": "Фінансы",
    "finance.page_eyebrow": "Аналітыка",
    "finance.title": "Фінансы",
    "finance.subtitle": "Баланс, папаўненні, вывады і гісторыя аперацый",
    "finance.period_30": "30 дзён",
    "finance.period_90": "90 дзён",
    "finance.period_all": "Увесь час",
    "finance.available_balance": "Даступны баланс",
    "finance.withdraw_restricted_hint": "Вывад сродкаў абмежаваны. Звярніцеся ў падтрымку.",
    "finance.withdraw_restricted": "Вывад абмежаваны",
    "finance.topup": "Папоўніць",
    "finance.withdraw": "Вывесці",
    "finance.pending_withdrawal": "Вывад у апрацоўцы",
    "finance.support": "Напісаць у падтрымку",
    "finance.nfts_in_portfolio": "NFT у партфелі",
    "finance.show": "Паказаць",
    "finance.turnover": "Абарот",
    "finance.dynamics_region": "Дынаміка",
    "finance.dynamics_title": "Дынаміка аперацый",
    "finance.period": "Перыяд",
    "finance.withdrawn": "Выведзена",
    "finance.deposited": "Папоўнена",
    "finance.skipped_currencies": "Аперацыі ў іншых валютах ({count}) не ўключаны ў вынік па выбранай валюце.",
    "finance.history_title": "Гісторыя аперацый",
    "finance.loading_history": "Загружаем гісторыю",
    "finance.history_empty_title": "Аперацый пакуль няма",
    "finance.history_empty_desc": "Папаўненні і вывады з'явяцца тут.",
    "finance.modal_topup": "Папаўненне балансу",
    "finance.modal_withdraw": "Вывад сродкаў",
    "finance.col_date": "Дата",
    "finance.col_type": "Тып",
    "finance.col_method": "Спосаб",
    "finance.col_details": "Рэквізіты",
    "finance.col_amount": "Сума",
    "finance.col_status": "Статус",
    "finance.status_expired": "Скончыўся тэрмін",
    "finance.status_pending": "Апрацоўка",
    "finance.status_rejected": "Адхілена",
    "finance.status_success": "Паспяхова",
    "finance.status_unknown": "Статус {status}",
    "finance.type_deposit": "Папаўненне",
    "finance.type_withdraw": "Вывад",
    "finance.type_unknown": "Аперацыя {type}",
    "finance.qr_hide": "Схаваць QR-код",
    "finance.invoice_title": "Рэквізіты для аплаты",
    "finance.invoice_subtitle": "Пераўвядзіце дакладную суму па ўказаных рэквізітах.",
    "finance.invoice_send_amount": "Сума да адпраўкі",
    "finance.invoice_open_payment": "Перайсці да аплаты",
    "finance.invoice_qr_hint": "Адсканіруйце ў праграме кашалька — адрас і сума падставяцца аўтаматычна.",
    "finance.invoice_time_to_pay": "Час на аплату",
    "finance.qr_show": "Паказаць QR-код",
    "finance.qr_alt": "QR-код кашалька для папаўнення",
    "finance.qr_caption": "Скануйце для аплаты",
    "finance.chart_empty": "Пакуль няма пацверджаных аперацый за выбраны перыяд.",
    "finance.chart_label": "Дынаміка балансу папаўненняў і вывадаў, цяпер {amount}",
    "finance.loading_methods": "Загружаем спосабы",
    "finance.error_min_amount": "Мінімальная сума — {amount}.",
    "finance.error_check_amount": "Праверце суму і спосаб аперацыі.",
    "finance.error_select_bank": "Выберыце банк для вываду праз СБП.",
    "finance.error_select_method": "Выберыце спосаб",
    "finance.page_topup": "Папаўненне",
    "finance.page_topup_desc": "Выберыце даступны спосаб і суму папаўнення",
    "finance.page_withdraw_desc": "Стварыце запыт на вывад на вашы рэквізіты",
    "finance.min_hint": "Мінімум {amount}",
    "finance.bank": "Банк",
    "finance.select_bank": "Выберыце банк",
    "finance.withdraw_blocked": "Вывад сродкаў часова недаступны для вашага акаўнта.",
    "finance.withdraw_created": "Запыт на вывад створаны.",
    "finance.sync_warning": "Не ўдалося абнавіць даныя акаўнта. Абнавіце старонку.",
    "finance.sending": "Адпраўляем…",
    "finance.continue": "Працягнуць",
    "finance.create_request": "Стварыць запыт",
    "finance.payment_created": "Плацёж створаны",
    "finance.payment_number": "Плацёж #{id}",
    "finance.open_payment": "Адкрыць аплату",
    "finance.paid_no_balance_title": "Аплацілі, але баланс не змяніўся?",
    "finance.paid_no_balance_desc": "Сродкі залічваюцца пасля пацвярджэння плацяжу. Калі гэтага не адбылося, напішыце ў падтрымку і ўкажыце нумар плацяжу.",
    "finance.confirmation_eyebrow": "Пацвярджэнне",
    "finance.confirm_title": "Пацвердзіце вывад",
    "finance.creating_request": "Ствараем запыт…",
    "finance.confirm_withdraw": "Пацвердзіць вывад",
    "finance.cancel": "Адмена",
    "finance.amount_due": "Сума да аплаты",
    "finance.network": "Сетка",
    "finance.wallet_address": "Адрас кашалька",
    "finance.copy_wallet": "Скапіяваць адрас кашалька",
    "finance.memo": "Memo / тэг",
    "finance.copy_memo": "Скапіяваць memo",
    "finance.pay_until": "Аплаціць да",
    "finance.minimum": "Мінімальная сума",
    "finance.network_warning": "Адпраўляйце сродкі толькі ў пазначанай сетцы. Перавод у іншай сетцы прывядзе да страты сродкаў.",
    "finance.time_left": "засталося {time}",
    "finance.time_expired": "час скончыўся",
    "finance.copied": "Скапіявана",
    "finance.finance_desk": "Фінансавы аддзел",
    "finance.copy": "Капіяваць",
    "finance.analytics_region": "Аналітыка партфеля",
    "finance.portfolio_value": "Ацэнка партфеля",
    "finance.portfolio_value_hint": "Ацэнка па бягучых цэнах",
    "finance.realized": "Рэалізаваны прыбытак",
    "finance.realized_hint": "Сума ўсіх продажаў мінус сума ўсіх пакупак",
    "finance.realized_unknown_hint": "Патрэбна цана пакупкі прададзеных NFT",
    "finance.spent": "Выдаткавана",
    "finance.received": "Атрымана",
    "finance.best": "Лепшы актыў",
    "finance.worst": "Горшы актыў",
    "finance.stats_unavailable": "Паказаны даступныя паказчыкі вашага партфеля.",
    "finance.portfolio_chart_title": "Кошт партфеля",
    "finance.portfolio_chart_unavailable": "Гісторыя кошту партфеля пакуль недаступная.",
    "finance.portfolio_chart_error": "Не ўдалося загрузіць графік.",
    "finance.loading_short": "Загружаем…",
    "finance.portfolio_chart_label": "Кошт партфеля, {period}",
    "finance.period_1d": "1 д",
    "finance.period_7d": "7 д",
    "finance.period_30d": "30 д",
    "finance.period_60d": "60 д",
    "finance.period_90d": "90 д",
    "finance.period_180d": "180 д",
    "finance.period_365d": "365 д",
    "finance.period_1y": "1 г",
    "finance.period_all_short": "Усё",
    "finance.owns_eyebrow": "Партфель",
    "finance.owns_title": "Мае NFT",
    "finance.tab_portfolio": "Партфель",
    "finance.tab_history": "Гісторыя",
    "finance.col_collection": "Калекцыя",
    "finance.col_token": "Токен ID",
    "finance.col_price": "Цана",
    "finance.nft_sold": "Прададзены",
    "finance.nft_on_sale": "На продажы",
    "finance.nft_bought": "Куплены",
    "finance.nft_in_collection": "У калекцыі",
    "finance.nft_history_empty_title": "Гісторыя пустая",
    "finance.nft_history_empty_desc": "Аперацыі з NFT з'явяцца тут.",
    "finance.items_count": "one:{count} прадмет|few:{count} прадметы|many:{count} прадметаў|other:{count} прадмета",
    "finance.search_placeholder": "Знайсці ў партфелі",
    "finance.loading_assets": "Загружаем актывы",
    "finance.assets_empty_title": "Актываў не знойдзена",
    "finance.assets_empty_query": "Змяніце пошукавы запыт.",
    "finance.assets_empty_desc": "Купленыя NFT з'явяцца тут."
  },
  de: {
    "finance.method_card": "Karte",
    "finance.method_sbp": "Schnellzahlung (SBP)",
    "finance.eyebrow": "Finanzen",
    "finance.page_eyebrow": "Analytik",
    "finance.title": "Finanzen",
    "finance.subtitle": "Guthaben, Einzahlungen, Auszahlungen und Transaktionsverlauf",
    "finance.period_30": "30 Tage",
    "finance.period_90": "90 Tage",
    "finance.period_all": "Gesamter Zeitraum",
    "finance.available_balance": "Verfügbares Guthaben",
    "finance.withdraw_restricted_hint": "Auszahlungen sind eingeschränkt. Wenden Sie sich an den Support.",
    "finance.withdraw_restricted": "Auszahlung eingeschränkt",
    "finance.topup": "Einzahlen",
    "finance.withdraw": "Auszahlen",
    "finance.pending_withdrawal": "Auszahlung in Bearbeitung",
    "finance.support": "Support kontaktieren",
    "finance.nfts_in_portfolio": "NFTs im Portfolio",
    "finance.show": "Anzeigen",
    "finance.turnover": "Umsatz",
    "finance.dynamics_region": "Verlauf",
    "finance.dynamics_title": "Transaktionsverlauf",
    "finance.period": "Zeitraum",
    "finance.withdrawn": "Ausgezahlt",
    "finance.deposited": "Eingezahlt",
    "finance.skipped_currencies": "Transaktionen in anderen Währungen ({count}) sind nicht im Gesamtbetrag der ausgewählten Währung enthalten.",
    "finance.history_title": "Transaktionsverlauf",
    "finance.loading_history": "Verlauf wird geladen",
    "finance.history_empty_title": "Noch keine Transaktionen",
    "finance.history_empty_desc": "Ein- und Auszahlungen erscheinen hier.",
    "finance.modal_topup": "Guthaben aufladen",
    "finance.modal_withdraw": "Guthaben auszahlen",
    "finance.col_date": "Datum",
    "finance.col_type": "Typ",
    "finance.col_method": "Methode",
    "finance.col_details": "Zahlungsdaten",
    "finance.col_amount": "Betrag",
    "finance.col_status": "Status",
    "finance.status_expired": "Abgelaufen",
    "finance.status_pending": "In Bearbeitung",
    "finance.status_rejected": "Abgelehnt",
    "finance.status_success": "Erfolgreich",
    "finance.status_unknown": "Status {status}",
    "finance.type_deposit": "Einzahlung",
    "finance.type_withdraw": "Auszahlung",
    "finance.type_unknown": "Transaktion {type}",
    "finance.qr_hide": "QR-Code ausblenden",
    "finance.invoice_title": "Zahlungsdetails",
    "finance.invoice_subtitle": "Überweisen Sie den genauen Betrag an die angegebenen Zahlungsdaten.",
    "finance.invoice_send_amount": "Zu sendender Betrag",
    "finance.invoice_open_payment": "Zur Zahlung",
    "finance.invoice_qr_hint": "Mit der Wallet-App scannen — Adresse und Betrag werden automatisch eingetragen.",
    "finance.invoice_time_to_pay": "Zeit zur Zahlung",
    "finance.qr_show": "QR-Code anzeigen",
    "finance.qr_alt": "QR-Code der Einzahlungs-Wallet",
    "finance.qr_caption": "Zum Bezahlen scannen",
    "finance.chart_empty": "Für den gewählten Zeitraum gibt es noch keine bestätigten Transaktionen.",
    "finance.chart_label": "Saldo aus Ein- und Auszahlungen im Zeitverlauf, aktuell {amount}",
    "finance.loading_methods": "Methoden werden geladen",
    "finance.error_min_amount": "Der Mindestbetrag beträgt {amount}.",
    "finance.error_check_amount": "Prüfen Sie Betrag und Methode.",
    "finance.error_select_bank": "Wählen Sie eine Bank für die SBP-Auszahlung.",
    "finance.error_select_method": "Wählen Sie eine Methode",
    "finance.page_topup": "Einzahlung",
    "finance.page_topup_desc": "Wählen Sie eine verfügbare Methode und den Einzahlungsbetrag",
    "finance.page_withdraw_desc": "Erstellen Sie eine Auszahlungsanfrage an Ihre Zahlungsdaten",
    "finance.min_hint": "Mindestens {amount}",
    "finance.bank": "Bank",
    "finance.select_bank": "Bank auswählen",
    "finance.withdraw_blocked": "Auszahlungen sind für Ihr Konto vorübergehend nicht verfügbar.",
    "finance.withdraw_created": "Auszahlungsanfrage erstellt.",
    "finance.sync_warning": "Kontodaten konnten nicht aktualisiert werden. Laden Sie die Seite neu.",
    "finance.sending": "Wird gesendet…",
    "finance.continue": "Weiter",
    "finance.create_request": "Anfrage erstellen",
    "finance.payment_created": "Zahlung erstellt",
    "finance.payment_number": "Zahlung #{id}",
    "finance.open_payment": "Zur Zahlung",
    "finance.paid_no_balance_title": "Bezahlt, aber das Guthaben hat sich nicht geändert?",
    "finance.paid_no_balance_desc": "Das Guthaben wird nach Bestätigung der Zahlung gutgeschrieben. Falls das nicht passiert ist, wenden Sie sich unter Angabe der Zahlungsnummer an den Support.",
    "finance.confirmation_eyebrow": "Bestätigung",
    "finance.confirm_title": "Auszahlung bestätigen",
    "finance.creating_request": "Anfrage wird erstellt…",
    "finance.confirm_withdraw": "Auszahlung bestätigen",
    "finance.cancel": "Abbrechen",
    "finance.amount_due": "Zu zahlender Betrag",
    "finance.network": "Netzwerk",
    "finance.wallet_address": "Wallet-Adresse",
    "finance.copy_wallet": "Wallet-Adresse kopieren",
    "finance.memo": "Memo / Tag",
    "finance.copy_memo": "Memo kopieren",
    "finance.pay_until": "Zahlen bis",
    "finance.minimum": "Mindestbetrag",
    "finance.network_warning": "Senden Sie Guthaben nur über das angegebene Netzwerk. Eine Überweisung über ein anderes Netzwerk führt zum Verlust der Mittel.",
    "finance.time_left": "noch {time}",
    "finance.time_expired": "Zeit abgelaufen",
    "finance.copied": "Kopiert",
    "finance.finance_desk": "Finanzabteilung",
    "finance.copy": "Kopieren",
    "finance.analytics_region": "Portfolio-Analyse",
    "finance.portfolio_value": "Portfoliowert",
    "finance.portfolio_value_hint": "Bewertung zu aktuellen Preisen",
    "finance.realized": "Realisierter Gewinn",
    "finance.realized_hint": "Summe aller Verkäufe minus Summe aller Käufe",
    "finance.realized_unknown_hint": "Kaufpreis der verkauften NFTs wird benötigt",
    "finance.spent": "Ausgegeben",
    "finance.received": "Erhalten",
    "finance.best": "Bestes Asset",
    "finance.worst": "Schwächstes Asset",
    "finance.stats_unavailable": "Die verfügbaren Kennzahlen Ihres Portfolios werden angezeigt.",
    "finance.portfolio_chart_title": "Portfoliowert",
    "finance.portfolio_chart_unavailable": "Der Verlauf des Portfoliowerts ist derzeit nicht verfügbar.",
    "finance.portfolio_chart_error": "Diagramm konnte nicht geladen werden.",
    "finance.loading_short": "Wird geladen…",
    "finance.portfolio_chart_label": "Portfoliowert, {period}",
    "finance.period_1d": "1 T",
    "finance.period_7d": "7 T",
    "finance.period_30d": "30 T",
    "finance.period_60d": "60 T",
    "finance.period_90d": "90 T",
    "finance.period_180d": "180 T",
    "finance.period_365d": "365 T",
    "finance.period_1y": "1 J",
    "finance.period_all_short": "Alle",
    "finance.owns_eyebrow": "Portfolio",
    "finance.owns_title": "Meine NFTs",
    "finance.tab_portfolio": "Portfolio",
    "finance.tab_history": "Verlauf",
    "finance.col_collection": "Kollektion",
    "finance.col_token": "Token-ID",
    "finance.col_price": "Preis",
    "finance.nft_sold": "Verkauft",
    "finance.nft_on_sale": "Im Verkauf",
    "finance.nft_bought": "Gekauft",
    "finance.nft_in_collection": "In der Sammlung",
    "finance.nft_history_empty_title": "Noch kein Verlauf",
    "finance.nft_history_empty_desc": "NFT-Transaktionen erscheinen hier.",
    "finance.items_count": "one:{count} Objekt|few:{count} Objekte|many:{count} Objekte|other:{count} Objekte",
    "finance.search_placeholder": "Im Portfolio suchen",
    "finance.loading_assets": "Assets werden geladen",
    "finance.assets_empty_title": "Keine Assets gefunden",
    "finance.assets_empty_query": "Ändern Sie die Suchanfrage.",
    "finance.assets_empty_desc": "Gekaufte NFTs erscheinen hier."
  },
  fr: {
    "finance.method_card": "Carte",
    "finance.method_sbp": "Paiement instantané (SBP)",
    "finance.eyebrow": "Finances",
    "finance.page_eyebrow": "Analytique",
    "finance.title": "Finances",
    "finance.subtitle": "Solde, dépôts, retraits et historique des opérations",
    "finance.period_30": "30 jours",
    "finance.period_90": "90 jours",
    "finance.period_all": "Depuis le début",
    "finance.available_balance": "Solde disponible",
    "finance.withdraw_restricted_hint": "Les retraits sont limités. Contactez le support.",
    "finance.withdraw_restricted": "Retraits limités",
    "finance.topup": "Déposer",
    "finance.withdraw": "Retirer",
    "finance.pending_withdrawal": "Retrait en cours",
    "finance.support": "Contacter le support",
    "finance.nfts_in_portfolio": "NFT en portefeuille",
    "finance.show": "Voir",
    "finance.turnover": "Volume d'échanges",
    "finance.dynamics_region": "Évolution",
    "finance.dynamics_title": "Évolution des opérations",
    "finance.period": "Période",
    "finance.withdrawn": "Retiré",
    "finance.deposited": "Déposé",
    "finance.skipped_currencies": "Les opérations dans d’autres devises ({count}) sont exclues du total dans la devise sélectionnée.",
    "finance.history_title": "Historique des opérations",
    "finance.loading_history": "Chargement de l'historique",
    "finance.history_empty_title": "Aucune opération pour l'instant",
    "finance.history_empty_desc": "Les dépôts et retraits apparaîtront ici.",
    "finance.modal_topup": "Alimenter le solde",
    "finance.modal_withdraw": "Retrait de fonds",
    "finance.col_date": "Date",
    "finance.col_type": "Type",
    "finance.col_method": "Méthode",
    "finance.col_details": "Coordonnées",
    "finance.col_amount": "Montant",
    "finance.col_status": "Statut",
    "finance.status_expired": "Expiré",
    "finance.status_pending": "En cours",
    "finance.status_rejected": "Refusé",
    "finance.status_success": "Réussi",
    "finance.status_unknown": "Statut {status}",
    "finance.type_deposit": "Dépôt",
    "finance.type_withdraw": "Retrait",
    "finance.type_unknown": "Opération {type}",
    "finance.qr_hide": "Masquer le QR code",
    "finance.invoice_title": "Coordonnées de paiement",
    "finance.invoice_subtitle": "Envoyez le montant exact avec les coordonnées ci-dessous.",
    "finance.invoice_send_amount": "Montant à envoyer",
    "finance.invoice_open_payment": "Aller au paiement",
    "finance.invoice_qr_hint": "Scannez avec votre portefeuille — l’adresse et le montant se remplissent automatiquement.",
    "finance.invoice_time_to_pay": "Temps pour payer",
    "finance.qr_show": "Afficher le QR code",
    "finance.qr_alt": "QR code du portefeuille de dépôt",
    "finance.qr_caption": "Scannez pour payer",
    "finance.chart_empty": "Aucune opération confirmée sur la période sélectionnée pour l'instant.",
    "finance.chart_label": "Solde net des dépôts et retraits dans le temps, actuellement {amount}",
    "finance.loading_methods": "Chargement des méthodes",
    "finance.error_min_amount": "Le montant minimum est de {amount}.",
    "finance.error_check_amount": "Vérifiez le montant et la méthode.",
    "finance.error_select_bank": "Choisissez une banque pour le retrait via SBP.",
    "finance.error_select_method": "Choisissez un mode de paiement",
    "finance.page_topup": "Dépôt",
    "finance.page_topup_desc": "Choisissez une méthode disponible et le montant du dépôt",
    "finance.page_withdraw_desc": "Créez une demande de retrait vers vos coordonnées",
    "finance.min_hint": "Minimum {amount}",
    "finance.bank": "Banque",
    "finance.select_bank": "Choisissez une banque",
    "finance.withdraw_blocked": "Les retraits sont temporairement indisponibles pour votre compte.",
    "finance.withdraw_created": "Demande de retrait créée.",
    "finance.sync_warning": "Impossible d'actualiser les données du compte. Rechargez la page.",
    "finance.sending": "Envoi…",
    "finance.continue": "Continuer",
    "finance.create_request": "Créer la demande",
    "finance.payment_created": "Paiement créé",
    "finance.payment_number": "Paiement n° {id}",
    "finance.open_payment": "Ouvrir le paiement",
    "finance.paid_no_balance_title": "Vous avez payé mais votre solde n'a pas changé ?",
    "finance.paid_no_balance_desc": "Les fonds sont crédités après confirmation du paiement. Si ce n'est pas le cas, contactez le support en indiquant le numéro du paiement.",
    "finance.confirmation_eyebrow": "Confirmation",
    "finance.confirm_title": "Confirmez le retrait",
    "finance.creating_request": "Création de la demande…",
    "finance.confirm_withdraw": "Confirmer le retrait",
    "finance.cancel": "Annuler",
    "finance.amount_due": "Montant à payer",
    "finance.network": "Réseau",
    "finance.wallet_address": "Adresse du portefeuille",
    "finance.copy_wallet": "Copier l'adresse du portefeuille",
    "finance.memo": "Mémo / tag",
    "finance.copy_memo": "Copier le mémo",
    "finance.pay_until": "Payer avant le",
    "finance.minimum": "Montant minimum",
    "finance.network_warning": "N'envoyez des fonds que sur le réseau indiqué. Un transfert sur un autre réseau entraînera la perte des fonds.",
    "finance.time_left": "{time} restantes",
    "finance.time_expired": "délai expiré",
    "finance.copied": "Copié",
    "finance.finance_desk": "Service financier",
    "finance.copy": "Copier",
    "finance.analytics_region": "Analyse du portefeuille",
    "finance.portfolio_value": "Valeur du portefeuille",
    "finance.portfolio_value_hint": "Estimation aux prix actuels",
    "finance.realized": "Plus-value réalisée",
    "finance.realized_hint": "Total des ventes moins total des achats",
    "finance.realized_unknown_hint": "Le prix d’achat des NFT vendus est requis",
    "finance.spent": "Dépensé",
    "finance.received": "Reçu",
    "finance.best": "Meilleur actif",
    "finance.worst": "Pire actif",
    "finance.stats_unavailable": "Les indicateurs disponibles de votre portefeuille sont affichés.",
    "finance.portfolio_chart_title": "Valeur du portefeuille",
    "finance.portfolio_chart_unavailable": "L’historique de la valeur du portefeuille est actuellement indisponible.",
    "finance.portfolio_chart_error": "Impossible de charger le graphique.",
    "finance.loading_short": "Chargement…",
    "finance.portfolio_chart_label": "Valeur du portefeuille, {period}",
    "finance.period_1d": "1 J",
    "finance.period_7d": "7 J",
    "finance.period_30d": "30 J",
    "finance.period_60d": "60 J",
    "finance.period_90d": "90 J",
    "finance.period_180d": "180 J",
    "finance.period_365d": "365 J",
    "finance.period_1y": "1 A",
    "finance.period_all_short": "Tout",
    "finance.owns_eyebrow": "Portefeuille",
    "finance.owns_title": "Mes NFT",
    "finance.tab_portfolio": "Portefeuille",
    "finance.tab_history": "Historique",
    "finance.col_collection": "Collection",
    "finance.col_token": "ID du jeton",
    "finance.col_price": "Prix",
    "finance.nft_sold": "Vendu",
    "finance.nft_on_sale": "En vente",
    "finance.nft_bought": "Acheté",
    "finance.nft_in_collection": "Dans la collection",
    "finance.nft_history_empty_title": "Historique vide",
    "finance.nft_history_empty_desc": "Les opérations sur les NFT apparaîtront ici.",
    "finance.items_count": "one:{count} objet|few:{count} objets|many:{count} d'objets|other:{count} objets",
    "finance.search_placeholder": "Rechercher dans le portefeuille",
    "finance.loading_assets": "Chargement des actifs",
    "finance.assets_empty_title": "Aucun actif trouvé",
    "finance.assets_empty_query": "Modifiez votre recherche.",
    "finance.assets_empty_desc": "Les NFT achetés apparaîtront ici."
  },
  cn: {
    "finance.method_card": "卡片",
    "finance.method_sbp": "快捷支付（SBP）",
    "finance.eyebrow": "财务",
    "finance.page_eyebrow": "分析",
    "finance.title": "财务",
    "finance.subtitle": "余额、充值、提现和交易记录",
    "finance.period_30": "30 天",
    "finance.period_90": "90 天",
    "finance.period_all": "全部时间",
    "finance.available_balance": "可用余额",
    "finance.withdraw_restricted_hint": "提现受限，请联系客服。",
    "finance.withdraw_restricted": "提现受限",
    "finance.topup": "充值",
    "finance.withdraw": "提现",
    "finance.pending_withdrawal": "提现处理中",
    "finance.support": "联系客服",
    "finance.nfts_in_portfolio": "持有的NFT",
    "finance.show": "查看",
    "finance.turnover": "交易额",
    "finance.dynamics_region": "动态",
    "finance.dynamics_title": "交易动态",
    "finance.period": "时间段",
    "finance.withdrawn": "已提现",
    "finance.deposited": "已充值",
    "finance.skipped_currencies": "其他币种的交易（{count}）不计入所选币种的合计。",
    "finance.history_title": "交易记录",
    "finance.loading_history": "正在加载记录",
    "finance.history_empty_title": "暂无交易",
    "finance.history_empty_desc": "充值和提现记录将显示在这里。",
    "finance.modal_topup": "余额充值",
    "finance.modal_withdraw": "提现",
    "finance.col_date": "日期",
    "finance.col_type": "类型",
    "finance.col_method": "方式",
    "finance.col_details": "收款信息",
    "finance.col_amount": "金额",
    "finance.col_status": "状态",
    "finance.status_expired": "已过期",
    "finance.status_pending": "处理中",
    "finance.status_rejected": "已拒绝",
    "finance.status_success": "成功",
    "finance.status_unknown": "状态 {status}",
    "finance.type_deposit": "充值",
    "finance.type_withdraw": "提现",
    "finance.type_unknown": "交易 {type}",
    "finance.qr_hide": "隐藏二维码",
    "finance.invoice_title": "付款信息",
    "finance.invoice_subtitle": "请按以下信息转入准确金额。",
    "finance.invoice_send_amount": "应转金额",
    "finance.invoice_open_payment": "前往支付",
    "finance.invoice_qr_hint": "用钱包应用扫描——地址和金额将自动填入。",
    "finance.invoice_time_to_pay": "支付时限",
    "finance.qr_show": "显示二维码",
    "finance.qr_alt": "充值钱包二维码",
    "finance.qr_caption": "扫码支付",
    "finance.chart_empty": "所选时间段内暂无已确认的交易。",
    "finance.chart_label": "充值与提现净额走势，当前 {amount}",
    "finance.loading_methods": "正在加载支付方式",
    "finance.error_min_amount": "最低金额为 {amount}。",
    "finance.error_check_amount": "请检查金额和方式。",
    "finance.error_select_bank": "请选择用于 SBP 提现的银行。",
    "finance.error_select_method": "请选择支付方式",
    "finance.page_topup": "充值",
    "finance.page_topup_desc": "选择可用的方式和充值金额",
    "finance.page_withdraw_desc": "创建提现到您收款账户的申请",
    "finance.min_hint": "最低 {amount}",
    "finance.bank": "银行",
    "finance.select_bank": "选择银行",
    "finance.withdraw_blocked": "您的账户暂时无法提现。",
    "finance.withdraw_created": "提现申请已创建。",
    "finance.sync_warning": "无法刷新账户数据，请刷新页面。",
    "finance.sending": "正在提交…",
    "finance.continue": "继续",
    "finance.create_request": "创建申请",
    "finance.payment_created": "付款已创建",
    "finance.payment_number": "付款 #{id}",
    "finance.open_payment": "前往付款",
    "finance.paid_no_balance_title": "已付款但余额未变化？",
    "finance.paid_no_balance_desc": "付款确认后资金将到账。如未到账，请联系客服并提供付款编号。",
    "finance.confirmation_eyebrow": "确认",
    "finance.confirm_title": "确认提现",
    "finance.creating_request": "正在创建申请…",
    "finance.confirm_withdraw": "确认提现",
    "finance.cancel": "取消",
    "finance.amount_due": "应付金额",
    "finance.network": "网络",
    "finance.wallet_address": "钱包地址",
    "finance.copy_wallet": "复制钱包地址",
    "finance.memo": "Memo / 标签",
    "finance.copy_memo": "复制 Memo",
    "finance.pay_until": "付款截止",
    "finance.minimum": "最低金额",
    "finance.network_warning": "请仅通过指定网络转账，使用其他网络转账将导致资金丢失。",
    "finance.time_left": "剩余 {time}",
    "finance.time_expired": "已超时",
    "finance.copied": "已复制",
    "finance.finance_desk": "财务部门",
    "finance.copy": "复制",
    "finance.analytics_region": "投资组合分析",
    "finance.portfolio_value": "投资组合估值",
    "finance.portfolio_value_hint": "按当前价格估算",
    "finance.realized": "已实现盈亏",
    "finance.realized_hint": "全部卖出总额减去全部买入总额",
    "finance.realized_unknown_hint": "需要已售出NFT的买入价",
    "finance.spent": "已支出",
    "finance.received": "已收到",
    "finance.best": "表现最佳",
    "finance.worst": "表现最差",
    "finance.stats_unavailable": "已显示可用的投资组合指标。",
    "finance.portfolio_chart_title": "投资组合价值",
    "finance.portfolio_chart_unavailable": "暂无投资组合价值历史。",
    "finance.portfolio_chart_error": "无法加载图表。",
    "finance.loading_short": "加载中…",
    "finance.portfolio_chart_label": "投资组合价值，{period}",
    "finance.period_1d": "1天",
    "finance.period_7d": "7天",
    "finance.period_30d": "30天",
    "finance.period_60d": "60天",
    "finance.period_90d": "90天",
    "finance.period_180d": "180天",
    "finance.period_365d": "365天",
    "finance.period_1y": "1年",
    "finance.period_all_short": "全部",
    "finance.owns_eyebrow": "投资组合",
    "finance.owns_title": "我的NFT",
    "finance.tab_portfolio": "投资组合",
    "finance.tab_history": "历史",
    "finance.col_collection": "收藏系列",
    "finance.col_token": "代币 ID",
    "finance.col_price": "价格",
    "finance.nft_sold": "已售出",
    "finance.nft_on_sale": "出售中",
    "finance.nft_bought": "已购买",
    "finance.nft_in_collection": "收藏中",
    "finance.nft_history_empty_title": "暂无记录",
    "finance.nft_history_empty_desc": "NFT交易记录将显示在这里。",
    "finance.items_count": "one:{count} 件|few:{count} 件|many:{count} 件|other:{count} 件",
    "finance.search_placeholder": "在投资组合中搜索",
    "finance.loading_assets": "正在加载资产",
    "finance.assets_empty_title": "未找到资产",
    "finance.assets_empty_query": "请修改搜索条件。",
    "finance.assets_empty_desc": "购买的NFT将显示在这里。"
  }
});
